// Shared form hooks report activity; JobHandler owns the refresh decision.
export function createFormActivity() {
  const drafts = new Set();
  const listeners = new Set();
  let saves = 0;
  let version = 0;
  const emit = () => { version++; listeners.forEach(listener => listener()); };
  return {
    subscribe: listener => { listeners.add(listener); return () => listeners.delete(listener); },
    snapshot: () => version,
    blocked: () => drafts.size > 0 || saves > 0,
    draft: (owner, dirty) => {
      if (drafts.has(owner) === dirty) return;
      if (dirty) drafts.add(owner); else drafts.delete(owner);
      emit();
    },
    saving: () => {
      saves++; emit(); let done = false;
      return () => { if (!done) { done = true; saves--; emit(); } };
    },
  };
}
export const formActivity = createFormActivity();
